import React, { useCallback, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bool, func, string } from 'prop-types';
import clsx from 'clsx';
import { debounce } from 'lodash';

import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';

import classes from './SearchInput.module.css';

const SearchInput = ({ 
    activeNavClient,
    activeNavCompany,
    activeNavEquipment,
    activeNavSite,
    className,
    endAdornment,
    hidden, 
    noRadius, 
    stopPropagation,
    search, 
    value,
    dispatch,
    ...props 
}) => {
    const [searchTerm, setSearchTerm] = useState(value);

    const debouncedSearch = useCallback(
        debounce(search, 1000, { trailing: true }),
        [search]
    );

    useEffect(() => {
        setSearchTerm(value);
    }, [activeNavCompany, activeNavClient, activeNavSite, activeNavEquipment]);

    if (hidden) {
        return null;
    }

    function handleChange(event) {
        const { value } = event.target;
        setSearchTerm(value);
        debouncedSearch(value);
    }

    function handleClick(event) {
        if (event && stopPropagation)
            event.stopPropagation();
    }

    return (
        <TextField
            className={clsx(classes.root, className)}
            InputProps={endAdornment ?
                {
                    classes: {
                        input:          classes.input,
                        notchedOutline: noRadius ? '' : classes.notchedOutline
                    },
                    endAdornment: (
                        <SearchIcon
                            className={classes.adornment}
                            color="disabled"
                        />
                    )
                }
                :
                {
                    classes: {
                        input:          classes.input,
                        notchedOutline: noRadius ? '' : classes.notchedOutline
                    },
                    startAdornment: (
                        <SearchIcon
                            className={classes.adornment}
                            color="disabled"
                        />
                    )
                }
            }
            variant="outlined"
            {...props}
            onChange={handleChange}
            onClick={handleClick}
            type="search"
            value={searchTerm || ''}
        />
    );
};

SearchInput.propTypes = {
    hidden:   false,
    noRadius: false,
    search:   () => {}
};

SearchInput.propTypes = {
    className: string,
    hidden:    bool,
    noRadius:  bool,
    search:    func
};

const mapStateToProps = state => {
    return {
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavClient:    state.bob.activeNavClient,
        activeNavSite:      state.bob.activeNavSite,
        activeNavEquipment: state.bob.activeNavEquipment
    };
};

export default connect(mapStateToProps)(SearchInput);
